import React, { useState } from 'react';
import './index.css';
import Sidebar from './components/Sidebar';
import Dashboard from './pages/Dashboard';
import Agents from './pages/Agents';
import ApprovalQueue from './pages/ApprovalQueue';
import Escalations from './pages/Escalations';
import Studio from './pages/Studio';
import Ambassadors from './pages/Ambassadors';
import Launchpad from './pages/Launchpad';
import AgentChat from './pages/AgentChat';

export default function App() {
  const [page, setPage] = useState('dashboard');
  return (
    <div className="app">
      <Sidebar page={page} setPage={setPage} />
      <main className="main-content">
        {page === 'dashboard'   && <Dashboard setPage={setPage} />}
        {page === 'agents'      && <Agents />}
        {page === 'chat'        && <AgentChat />}
        {page === 'approval'    && <ApprovalQueue />}
        {page === 'escalations' && <Escalations />}
        {page === 'studio'      && <Studio />}
        {page === 'ambassadors' && <Ambassadors />}
        {page === 'launchpad'   && <Launchpad />}
      </main>
    </div>
  );
}
